import { useCallback, useState } from "react";

import { API_V2_UPDATE_CC_EMAIL } from "../../../../../config/Endpoints.js";
import { getAuthToken } from "../../../../../utils/Storage.js";
import { ApiError, putApi } from "../../../../utils/api.ts";
import {
  COMPANY_EMAIL_ERROR,
  isCompanyEmail,
} from "../schemas/it-approval-form.schema.ts";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";
import { SQE_ONBOARDING } from "../../onboarding/sqe/sqe-onboarding-api.ts";

function accessToken(): string | undefined {
  const t = getAuthToken("accessToken");
  return t != null && t !== "" ? t : undefined;
}

export function useItApprovalUpdateCcEmail(sqeEmployee = false) {
  const isSqe = useSqeLabs() || sqeEmployee;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateCcEmail = useCallback(async (employeeId: string | number, email: string) => {
    setLoading(true);
    setError(null);
    const trimmed = email.trim();
    if (!(isSqe ? /^[^\s@]+@sqelabs\.com$/i.test(trimmed) : isCompanyEmail(trimmed))) {
      setLoading(false);
      const message = isSqe ? "Please use an @sqelabs.com email address" : COMPANY_EMAIL_ERROR;
      setError(message);
      throw new ApiError(message, 400);
    }
    const url = isSqe
      ? `${SQE_ONBOARDING}/update-email?tempUserId=${encodeURIComponent(String(employeeId))}&email=${encodeURIComponent(trimmed)}`
      : `${API_V2_UPDATE_CC_EMAIL}?email=${encodeURIComponent(trimmed)}&employeeId=${encodeURIComponent(String(employeeId))}`;
    try {
      const { data } = await putApi<{ message?: string }>(url, accessToken(), {});
      return data;
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : "Failed to update company email.";
      setError(msg);
      throw e;
    } finally {
      setLoading(false);
    }
  }, [isSqe]);

  return { updateCcEmail, loading, error };
}
